import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import '../client/temp-common-imports';

export class ErrorCallbackController implements Controller {
  public pageId = '404';
  public path = '*';
  public routeName = 'errorpage';
  public exact = true;
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "error-page" */ '../views/error-callback-page'));

  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  public fetchPageData() {
    return Promise.resolve({ title: 'Page Not Found' });
  }
}